"use strict";
// This file is auto-generated by @hey-api/openapi-ts
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMembershipStatusV2Handler = exports.postClaimReview = exports.postClaim = exports.postSyncV1 = exports.postAgentClaim = exports.patchClaim = exports.getTouchMemberships = exports.getHealth = exports.getClaims = exports.getClaimById = exports.postBecomeAmember = exports.getMembershipStatusV1Handler = exports.deleteMembership = exports.postAgentManualCorrection = void 0;
/**
 * Submit a bespaartegoed correction from Cockpit
 * @param data The data for the request.
 * @param data.customerId BP or customer id
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const postAgentManualCorrection = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/loyalty/agent/transaction/{customerId}/v1',
        path: {
            customerId: data.customerId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'NO_ACTIVE_MEMBERSHIP_FOUND',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postAgentManualCorrection = postAgentManualCorrection;
/**
 * Unsubscribe from membership
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @throws ApiError
 */
const deleteMembership = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'DELETE',
        url: '/loyalty/membership/v1',
        query: {
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.deleteMembership = deleteMembership;
/**
 * Get membership status
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @returns GetMembershipStatusV1Response OK
 * @throws ApiError
 */
const getMembershipStatusV1Handler = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/loyalty/membership/v1',
        query: {
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMembershipStatusV1Handler = getMembershipStatusV1Handler;
/**
 * Become a member
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @returns PostBecomeAMemberV1Response OK
 * @throws ApiError
 */
const postBecomeAmember = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/loyalty/membership/v1',
        query: {
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'NO_ACTIVE_CONTRACT',
            406: 'MEMBERSHIP_DECLINED',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postBecomeAmember = postBecomeAmember;
/**
 * Get claim by id
 * @param data The data for the request.
 * @param data.claimId The claim id
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @returns GetClaimByIdResponse OK
 * @throws ApiError
 */
const getClaimById = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/loyalty/claim/v1',
        query: {
            claimId: data.claimId,
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: 'CLAIM_NOT_FOUND',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getClaimById = getClaimById;
/**
 * Get active claims for a member
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @returns GetClaimsResponse OK
 * @throws ApiError
 */
const getClaims = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/loyalty/claims/v1',
        query: {
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getClaims = getClaims;
/**
 * Check service availability
 * @returns HealthResponse OK
 * @throws ApiError
 */
const getHealth = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/loyalty/health',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getHealth = getHealth;
/**
 * Get account numbers for an access token, filters out any non-loyalty accounts
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @throws ApiError
 */
const getTouchMemberships = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/loyalty/touch/memberships/v1',
        query: {
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getTouchMemberships = getTouchMemberships;
/**
 * Update a claim via the cockpit workflow
 * @param data The data for the request.
 * @param data.customerId customer id
 * @param data.claimId The claim id
 * @param data.requestBody
 * @returns unknown OK
 * @throws ApiError
 */
const patchClaim = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'PATCH',
        url: '/loyalty/agent/claim/{customerId}/{claimId}/v1',
        path: {
            customerId: data.customerId,
            claimId: data.claimId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.patchClaim = patchClaim;
/**
 * Create a new claim via the cockpit workflow
 * @param data The data for the request.
 * @param data.customerId BP or customer id
 * @returns unknown OK
 * @throws ApiError
 */
const postAgentClaim = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/loyalty/agent/claim/{customerId}/v1',
        path: {
            customerId: data.customerId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            409: 'ACTIVE_CLAIM_ALREADY_EXISTS',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postAgentClaim = postAgentClaim;
/**
 * Register membership in SAP sync
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @returns PostBecomeAMemberV1Response OK
 * @throws ApiError
 */
const postSyncV1 = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/loyalty/membership/sync/v1',
        query: {
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'NO_ACTIVE_CONTRACT',
            406: 'MEMBERSHIP_DECLINED',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postSyncV1 = postSyncV1;
/**
 * Create a new claim
 * @param data The data for the request.
 * @param data.requestBody
 * @returns PostClaimResponse OK
 * @throws ApiError
 */
const postClaim = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/loyalty/customer/claim/v1',
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            409: 'ACTIVE_CLAIM_ALREADY_EXISTS',
            422: 'INVALID_VALUE',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postClaim = postClaim;
/**
 * Review of a claim by an agent
 * @param data The data for the request.
 * @param data.customerId customer id
 * @param data.claimId The internal id of the claim
 * @param data.requestBody
 * @returns PostClaimReviewResponse OK
 * @throws ApiError
 */
const postClaimReview = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'POST',
        url: '/loyalty/claim/agent/review/{customerId}/{claimId}/v1',
        path: {
            customerId: data.customerId,
            claimId: data.claimId
        },
        body: data.requestBody,
        mediaType: 'application/json',
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            406: 'CLAIM_PAYOUT_REJECTED',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.postClaimReview = postClaimReview;
/**
 * Get membership status
 * @param data The data for the request.
 * @param data.accountId The business partner id of the account to lookup the contract groups
 * @returns GetMembershipStatusV2Response OK
 * @throws ApiError
 */
const getMembershipStatusV2Handler = (data, client, headerOverrides) => {
    return client.makeRequest({
        method: 'GET',
        url: '/loyalty/membership/v2',
        query: {
            account_id: data.accountId
        },
        errors: {
            400: 'input_validation',
            403: 'unauthorized',
            404: '_not_found',
            500: '',
            504: 'backend_unavailable'
        }
    }, headerOverrides);
};
exports.getMembershipStatusV2Handler = getMembershipStatusV2Handler;
